module.exports = __webpack_public_path__ + "static/media/Victoria McCray.8423e1dd.png";